export const PASSWORD_REQUIREMENTS_MESSAGE =
  "Password must be at least 8 characters and include uppercase, lowercase, number, and special character.";

export const PASSWORD_REQUIREMENTS_HELPER =
  "Use at least 8 characters with uppercase, lowercase, number, and special character.";

export const isStrongPassword = (password) => {
  const value = String(password || "");
  const hasMinLength = value.length >= 8;
  const hasUpper = /[A-Z]/.test(value);
  const hasLower = /[a-z]/.test(value);
  const hasNumber = /\d/.test(value);
  const hasSpecial = /[^A-Za-z0-9]/.test(value);
  return hasMinLength && hasUpper && hasLower && hasNumber && hasSpecial;
};

export const validateChangePasswordForm = ({
  currentPassword = "",
  newPassword = "",
  confirmPassword = "",
} = {}) => {
  const current = String(currentPassword || "");
  const next = String(newPassword || "");
  const confirm = String(confirmPassword || "");

  if (!current) {
    return "Please enter your current password.";
  }

  if (!next) {
    return "Please enter a new password.";
  }

  if (!confirm) {
    return "Please confirm your new password.";
  }

  if (next !== confirm) {
    return "New passwords do not match.";
  }

  if (!isStrongPassword(next)) {
    return PASSWORD_REQUIREMENTS_MESSAGE;
  }

  if (next === current) {
    return "Your new password must be different from your current password.";
  }

  return "";
};

export const validateResetPasswordForm = ({ newPassword = "", confirmPassword = "" } = {}) => {
  const next = String(newPassword || "");
  const confirm = String(confirmPassword || "");

  if (!next) {
    return "Please enter a new password.";
  }

  if (!confirm) {
    return "Please confirm your new password.";
  }

  if (next !== confirm) {
    return "New passwords do not match.";
  }

  if (!isStrongPassword(next)) {
    return "Your new password does not meet the password requirements.";
  }

  return "";
};
